/**
 * Tạo bản sao độc lập cho state của từng form từ dữ liệu API.
 * Chỉ clone plain object/array vì response Customer Service không chứa class instance.
 */
export const cloneCustomerServiceFormData = (value) => {
    if (Array.isArray(value)) {
        return value.map(cloneCustomerServiceFormData);
    }

    if (value && typeof value === 'object') {
        return Object.keys(value).reduce((result, key) => {
            result[key] = cloneCustomerServiceFormData(value[key]);
            return result;
        }, {});
    }

    return value;
};

/** Bổ sung mode mặc định khi options role tải sau mà không ghi đè state đã bind. */
export const appendMissingAllocationModes = (modes = [], roleKeys = []) => {
    const currentModes = Array.isArray(modes) ? modes : [];
    const existingRoleKeys = new Set(currentModes.map(row => row.role_key));
    const missingModes = (roleKeys || [])
        .filter(roleKey => !existingRoleKeys.has(roleKey))
        .map(roleKey => ({
            role_key: roleKey,
            allocation_mode: 'equal_split',
            is_manual_override: false,
        }));

    return missingModes.length ? [...currentModes, ...missingModes] : currentModes;
};

const DIRECT_DOCTOR_FIELDS = [
    'treatment_doctor_ids',
    'implant_doctor_ids',
    'prosthetic_doctor_ids',
];

/** Đồng bộ lựa chọn nhân sự với xác nhận "Chưa xác định" cho mọi form Customer Service. */
export const applyUnknownStaffFieldChange = (item = {}, name, value) => {
    const next = { ...item, [name]: value };

    if (name === 'sales_unknown' && value === true) {
        next.sales = [];
    }

    if (name === 'direct_doctor_unknown' && value === true) {
        DIRECT_DOCTOR_FIELDS.forEach(field => {
            next[field] = [];
        });
    }

    if (name === 'sales' && (value || []).length) {
        next.sales_unknown = false;
    }

    if (DIRECT_DOCTOR_FIELDS.includes(name) && (value || []).length) {
        next.direct_doctor_unknown = false;
    }

    return next;
};
